import classNames from "classnames";
import { Form, Formik } from "formik";
import React from "react";
import style from "../../assets/css/components/Form/FormPlayers.module.css";
import { AddPlayedInitialState } from "../../utils/gamePlayed";
import Button from "../Button/Button";
import CheckPlayer from "../Input/CheckPlayer";

import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import { socket } from "../../config/socket";
const MySwal = withReactContent(Swal);

function FormPlayers({ playersLocal, playersVisit }) {
  const handleSubmit = async (values) => {
    // console.log(values.players);

    values.players.forEach((player, index) => {
      socket.emit("updatePlayed", { player }, (played) => {
        if (index === values.players.length - 1)
          MySwal.fire("Juegos jugados actualizados");
      });
    });
  };
  return (
    <Formik initialValues={AddPlayedInitialState} onSubmit={handleSubmit}>
      <Form className={classNames(style.form, style.formLive)}>
        <div
          className={style.formColumn}
          role="group"
          aria-labelledby="checkbox-group"
        >
          <div className={style.local}>
            {playersLocal.map((data) => (
              <CheckPlayer
                key={data.value}
                name="players"
                player={data.label}
                value={data.value}
              />
            ))}
          </div>
          <div className={style.visit}>
            {playersVisit.map((data) => (
              <CheckPlayer
                key={data.value}
                name="players"
                player={data.label}
                value={data.value}
              />
            ))}
          </div>
        </div>
        <Button text="Guardar" />
      </Form>
    </Formik>
  );
}

export default FormPlayers;
